import React from "react";
import PropTypes from "prop-types";

const SeeMore = ({ semCredito, comCredito, open, setOpen }) => {
  if (!semCredito || semCredito.length === 0) {
    return null;
  }


  const ordenar = (lista) => {
    if (!Array.isArray(lista)) return [];
    return [...lista].sort((a, b) => {
      const ordemFixa = [
        "Soma de Pontos",
        "CAMPANHA",
        "Pontuação Final"
      ];
      const aIndex = ordemFixa.indexOf(a.nome);
      const bIndex = ordemFixa.indexOf(b.nome);
      const aEhEspecial = aIndex !== -1;
      const bEhEspecial = bIndex !== -1;
      if (aEhEspecial && bEhEspecial) {
        return aIndex - bIndex;
      }
      if (aEhEspecial) return 1;
      if (bEhEspecial) return -1;
      const aHasPercent = a.percentual && a.percentual !== 0;
      const bHasPercent = b.percentual && b.percentual !== 0;
      if (aHasPercent && !bHasPercent) return -1;
      if (!aHasPercent && bHasPercent) return 1;
      if (aHasPercent && bHasPercent) {
        return b.percentual - a.percentual;
      }
      return 0;
    });
  };


  const semCreditoOrdenado = ordenar(semCredito);
  const comCreditoOrdenado = ordenar(comCredito);
  const hasComCredito = Array.isArray(comCredito) && comCredito.length > 0;
  const gridColsClass = hasComCredito ? "grid-cols-[2fr_1fr_1fr]" : "grid-cols-[2fr_1fr]";


  const formatPontos = (pontos) => {
    if (pontos === undefined || pontos === null) return "";
    const num = typeof pontos === "string" ? parseFloat(pontos.replace(",", ".")) : Number(pontos);
    if (Number.isNaN(num)) return pontos;
    return Math.round(num).toLocaleString("pt-BR", { maximumFractionDigits: 0 });
  };



  return (
    <div className="bg-white border-r border-l rounded-bl-lg rounded-br-lg border-b border-[#F2F2EF]-900">
      {open && (
        <div>
          <div className="w-full bg-white px-6 pt-6">
            <div className={`grid ${gridColsClass} text-end pr-4 font-bold mb-3`}>
              <div></div>
              <div className="text-red-600 text-center">Ponderado sem crédito</div>
              {hasComCredito && <div className="text-green-600 text-center">Ponderado com crédito</div>}
            </div>
            {semCreditoOrdenado.map((item, index) => {
              const itemComCredito = hasComCredito ? comCreditoOrdenado[index] : undefined;
              return (
                <div key={index}>
                  <div
                    className={`grid ${gridColsClass} text-center py-2
                      ${item.nome === "Pontuação Final" ? "bg-[#DAEBDE] text-[#000000] rounded-md font-bold" : ""}
                      ${item.nome === "Soma de Pontos" ? "text-[#000000] font-bold" : ""}
                    `}
                  >
                    <div className="flex flex-col items-end pr-4 justify-center font-semibold text-sm text-left">
                      {item.nome}{" "}
                      {item.percentual !== 0 && item.percentual && `(${item.percentual}%)`}
                    </div>

                    <div
                      className={`flex flex-col items-center pr-4 justify-center text-sm ${
                        item.destaque ? "font-bold" : ""
                      }`}
                    >
                      {formatPontos(item.pontos)} pontos
                      {item.sub && (
                        <div className="text-[11px] text-gray-600 mt-[-2px]">
                          ({item.sub})
                        </div>
                      )}
                    </div>

                    {hasComCredito && (
                      <div
                        className={`flex flex-col text-center pr-4 justify-center text-sm ${
                          itemComCredito && itemComCredito.destaque ? "font-bold" : ""
                        }`}
                      >
                        {itemComCredito ? (
                          <>
                            {formatPontos(itemComCredito.pontos)} pontos
                            {itemComCredito.sub && (
                              <div className="text-[11px] text-gray-600 mt-[-2px]">
                                ({itemComCredito.sub})
                              </div>
                            )}
                          </>
                        ) : (
                          <span className="text-gray-400">-</span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      <button
        onClick={() => setOpen(!open)}
        className="flex items-center max-w-[200px] mx-auto gap-2 bg-white px-3 py-2 rounded-md cursor-pointer select-none"
      >
        <span>{open ? "Ver menos" : "Ver mais"}</span>

        <svg
          width="13"
          height="11"
          viewBox="0 0 13 11"
          fill="none"
          className={`transform transition-transform duration-300 ${
            open ? "rotate-180" : ""
          }`}
        >
          <path
            opacity="0.3"
            d="M6.89473 10.834L12.8038 5.01107C12.9291 4.88685 13 4.71345 13 4.52971L13 0.647725C13 0.392808 12.8629 0.161183 12.6502 0.0563693C12.4363 -0.0471502 12.1869 -0.00444836 12.0144 0.166359L6.5 5.59984L0.986818 0.166359C0.813091 -0.00444849 0.563727 -0.0484444 0.351 0.0563692C0.137092 0.161183 9.4899e-07 0.392808 9.4595e-07 0.647725L8.99658e-07 4.52971C8.97467e-07 4.71345 0.072091 4.88685 0.195001 5.01107L6.10409 10.834C6.32864 11.0553 6.67136 11.0553 6.89473 10.834Z"
            fill="#01054C"
          />
        </svg>
      </button>
    </div>
  );
};

SeeMore.propTypes = {
  semCredito: PropTypes.arrayOf(
    PropTypes.shape({
      nome: PropTypes.string.isRequired,
      percentual: PropTypes.number,
      pontos: PropTypes.number.isRequired,
      bonusSalarial: PropTypes.string,
      destaque: PropTypes.bool,
      final: PropTypes.bool,
    })
  ).isRequired,
  comCredito: PropTypes.arrayOf(
    PropTypes.shape({
      pontos: PropTypes.number.isRequired,
      bonusSalarial: PropTypes.string,
      destaque: PropTypes.bool,
    })
  ),
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};

export default SeeMore;